<template>
  <Teleport to="body">
    <Transition name="naa-fade">
      <div v-if="current" class="naa-overlay">
        <div class="naa-box" role="alertdialog" aria-live="assertive" aria-label="Novo atendimento atribuído">
          <div class="naa-icon">🎧</div>
          <div class="naa-title">Novo atendimento atribuído</div>
          <div class="naa-desc">
            Um novo atendimento foi atribuído a você<template v-if="current.contactName">
              — <strong>{{ current.contactName }}</strong></template> (conversa #{{ current.convId }}).
          </div>
          <div class="naa-actions">
            <button type="button" class="naa-btn naa-btn--primary" @click="handleStart">
              Iniciar atendimento
            </button>
            <button type="button" class="naa-btn naa-btn--secondary" @click="handleDismiss">
              Dispensar
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { pendingAssignments, dismissCurrentAssignmentAlert } from '@/composables/useAssignmentAlert'
import { requestOpenChat } from '@/composables/useChatTrigger'

// Só o primeiro da fila fica visível — os demais aparecem um a um, conforme
// o agente for dispensando (igual fila de toast, mas bloqueante).
const current = computed(() => pendingAssignments.value[0] ?? null)

function handleStart() {
  if (!current.value) return
  requestOpenChat(current.value.convId)
  dismissCurrentAssignmentAlert('atendido')
}

/** Fecha o popup (e para o call.mp3, via dismissCurrentAssignmentAlert) sem abrir a conversa. */
function handleDismiss() {
  if (!current.value) return
  dismissCurrentAssignmentAlert('dispensado')
}
</script>

<style scoped>
.naa-overlay {
  position: fixed;
  inset: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, .55);
  display: flex;
  align-items: center;
  justify-content: center;
}

.naa-box {
  background: var(--white);
  border-radius: var(--r);
  padding: 32px;
  width: 360px;
  max-width: calc(100vw - 32px);
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, .3);
}

.naa-icon {
  font-size: 36px;
  margin-bottom: 8px;
}

.naa-title {
  font-size: 17px;
  font-weight: 700;
  color: var(--ink-80);
  margin-bottom: 8px;
}

.naa-desc {
  font-size: 13px;
  color: var(--ink-40);
  line-height: 1.5;
  margin-bottom: 22px;
}

.naa-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.naa-btn {
  padding: 10px 16px;
  border-radius: var(--r-sm);
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  border: none;
  font-family: inherit;
}

.naa-btn--primary {
  background: var(--red);
  color: #fff;
}

.naa-btn--secondary {
  background: transparent;
  color: var(--ink-40);
  border: 1.5px solid var(--ink-10);
}

.naa-btn--secondary:hover {
  background: var(--ink-02);
}

.naa-fade-enter-active,
.naa-fade-leave-active {
  transition: opacity .15s ease;
}

.naa-fade-enter-from,
.naa-fade-leave-to {
  opacity: 0;
}
</style>
